import AnalyticsAdminItemModelBase from '../_generated/modelBases/analytics-admin-item-model-base';

export default class AnalyticsAdminItemModel extends AnalyticsAdminItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
